import { render, staticRenderFns } from "./parkingAreaManageList.vue?vue&type=template&id=5185e1d4&scoped=true"
import script from "./parkingAreaManageList.vue?vue&type=script&lang=js"
export * from "./parkingAreaManageList.vue?vue&type=script&lang=js"
import style0 from "./parkingAreaManageList.vue?vue&type=style&index=0&id=5185e1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185e1d4",
  null
  
)

export default component.exports